import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import style from './Table.scss';
import { checkboxValidation, TableRow } from '.';

export default class Table extends React.Component {
  static propTypes = {
    columns: PropTypes.arrayOf(PropTypes.object).isRequired,
    source: PropTypes.array.isRequired,
    enableCheckboxes: PropTypes.bool,
    onCheckChange: checkboxValidation,
    rowAuth: PropTypes.func,
    rowAuthMsg: PropTypes.string,
    onlyShowAuthenticated: PropTypes.bool,
    toggleAuthenticatedPages: PropTypes.func,
    disabledRowCount: PropTypes.number,
    disabledRowIds: PropTypes.array,
    rightOfTable: PropTypes.node,
    checkedIds: PropTypes.array,
    builderListViewFeature: PropTypes.bool,
  }

  static defaultProps = {
    onlyShowAuthenticated: false,
    checkedIds: [],
    disabledRowCount: 0,
    builderListViewFeature: false,
  }

  constructor(props) {
    super(props);

    this.state = {};

    this.checkAllBox = React.createRef();
  }

  static getDerivedStateFromProps(props, state) {
    if (props.checkedIds && props.checkedIds.length) {
      return {
        checkedIds: props.checkedIds,
      };
    }
    return state;
  }

  componentDidMount = () => this.updateCheckAll();

  componentDidUpdate = () => this.updateCheckAll();

  onCheckAll = (e) => {
    const { source, disabledRowIds, onCheckChange } = this.props;
    const ids = e.target.checked ? source.reduce((enabled, item) => {
      if (!disabledRowIds.includes(item.id)) enabled.push(item.id);
      return enabled;
    }, []) : [];
    onCheckChange(ids);
  }

  onItemCheck = (e, id) => {
    const { onCheckChange, checkedIds } = this.props;

    if (e.target.checked) {
      const newCheckedIds = [...checkedIds, id];
      onCheckChange(newCheckedIds);
    } else {
      const idx = checkedIds.indexOf(id);
      if (idx < 0) {
        return;
      }
      const newCheckedIds = checkedIds.filter((item, index) => index !== idx);
      onCheckChange(newCheckedIds);
    }
  }

  updateCheckAll = () => {
    const { checkedIds, source, disabledRowCount } = this.props;
    const checkAllBox = this.checkAllBox.current;
    if (!checkAllBox) return;

    checkAllBox.indeterminate = checkedIds.length < (source.length - disabledRowCount) && checkedIds.length > 0;
    checkAllBox.checked = checkedIds.length === (source.length - disabledRowCount);
  }

  renderHeaders() {
    const { columns, enableCheckboxes, builderListViewFeature } = this.props;

    const headers = enableCheckboxes && builderListViewFeature ?
      [
        <th key="th-cb" className={style.checkboxColumnn}>
          <input type="checkbox" onChange={this.onCheckAll} ref={this.checkAllBox} />
        </th>,
      ] : [
        <th key="th-cb" className={style.checkboxColumnn} />,
      ];

    headers.push(...columns.map((column, idx) => (
      <th key={`th-${column.title}-${idx}`} className={column.style}>
        {column.title}
      </th>
    )));

    return headers;
  }

  renderRows = () => {
    const {
      columns,
      source,
      enableCheckboxes,
      rowAuth,
      rowAuthMsg,
      onlyShowAuthenticated,
      toggleAuthenticatedPages,
      disabledRowCount,
      checkedIds,
    } = this.props;

    return source.map(item => (
      <TableRow
        key={item.id}
        item={item}
        rowAuth={rowAuth}
        onlyShowAuthenticated={onlyShowAuthenticated}
        toggleAuthenticatedPages={toggleAuthenticatedPages}
        rowAuthMsg={rowAuthMsg}
        disabledRowCount={disabledRowCount}
        enableCheckboxes={enableCheckboxes}
        columns={columns}
        onCheck={this.onItemCheck}
        isChecked={!!checkedIds.find(id => id === item.id)}
        builderListViewFeature
        rowStyle={item.rowStyle}
      />
    ));
  }

  render() {
    const { rightOfTable } = this.props;

    return (
      <div className={style.tableView}>
        <Row>
          <Col xs={rightOfTable ? 9 : 12}>
            <table className={style.table}>
              <thead>
                <tr className={style.tableHeaders}>
                  {this.renderHeaders()}
                </tr>
              </thead>
              <tbody>
                {this.renderRows()}
              </tbody>
            </table>
          </Col>
          {rightOfTable &&
            <Col xs={3}>
              <div>
                {rightOfTable}
              </div>
            </Col>
          }
        </Row>
      </div>
    );
  }
}
